<template>
  <el-table :data="tableSafetyData" stripe style="width: 100%" ref="stationTable" border v-loading="stationsLoading">

    <af-table-column prop="operatorName" label="运营商"></af-table-column>
    <af-table-column prop="matter" label="安全检查事项"></af-table-column>
    <af-table-column prop="stationName" label="充电站名称"></af-table-column>
    <af-table-column prop="dutyPerson" label="客户联系人"></af-table-column>
    <af-table-column prop="salesman" label="销售人"></af-table-column>
    <af-table-column prop="warrantyPeriod" label="保修时间"></af-table-column>
    <af-table-column prop="auditStatus.message" label="状态"></af-table-column>
    <af-table-column label="操作" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="safetyEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:station:updateStation'])">编辑
        </el-button>
        <el-button size="mini" plain type="danger" @click="stationDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:station:deleteStation'])">删除
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  import safetyApi from "../../api/safetyApi";

  export default {
    name: "list",
    data(){
      return{
      }
    },
    props:{
      tableSafetyData: {},
      stationsLoading: false,
    },
    methods:{
      safetyEdit(index,row){
        this.$emit('safetyEdit',index,row)
      },

      // 删除管理信息
      stationDelete(index, row) {
        this.$confirm('确定要删除：' + row.matter + '吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            safetyApi.deleteSafety(row.id).then((res) => {
              console.log("删除结果：" + JSON.stringify(res))
              if (res.code === 0) {
                this.$message({
                  message: res.message,
                  type: 'success'
                })
                this.$emit("submitSafetySearchForm")
              } else {
                this.$message.error(res.message)
              }
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除！'
            })
          })
      },
    },
    filters: {
      statusFilter(stationStatus) {
        const statusMap = {
          0: 'warning',
          1: 'primary',
          5: 'info',
          6: 'danger',
          50: 'success'
        }
        return statusMap[stationStatus]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/safetyManager/list.vue